// extracted by mini-css-extract-plugin
export var bodyRow = "_cd-d";
export var cardColumns = "_cd-e";
export var ellipsesOverflow = "_cd-2";
export var flatBottomCorners = "_cd-3";
export var flatTopCorners = "_cd-4";
export var headerActionsDropdown = "_cd-f";
export var headerBottomRow = "_cd-c";
export var headerTopRow = "_cd-b";
export var orderDetailsWrapper = "_cd-0";
export var orderInfoContainer = "_cd-1";
export var productDetails = "_cd-9";
export var productImage = "_cd-5";
export var responsiveTable = "_cd-8";
export var shipmentContainer = "_cd-a";
export var tableBottomLeft = "_cd-6";
export var tableBottomRight = "_cd-7";
export var trackingLink = "_cd-g";